// Service-catalog feature — query-key gyár + a lista-szűrő típusa. A tényleges hívásokat a route a tipizált
// ts-rest kliensen (`api.serviceCatalog.query`) intézi; a kulcsok itt élnek (cache-egységesítés). A
// `@atlas/contracts` a szerződés forrás-igazsága — itt csak kulcs-logika van (az invoices minta).

/** A lista-lekérdezés szűrői (a query-kulcs része — szűrő-/rendezés-váltás új cache-bejegyzést nyit).
 *  A `q` a név-keresés, a `category`/`status` a toolbar-szűrők, a `sort` a rendezés-KULCS
 *  (name | planCount | priceRange), az `order` az irány. */
export interface ServiceCatalogListFilters {
  q: string;
  category: string;
  status: string;
  sort: string;
  order: 'asc' | 'desc';
}

/** Query-kulcs gyár — a lista- és a detail-cache egységes címzése. */
export const serviceCatalogKeys = {
  all: ['service-catalog'] as const,
  lists: () => ['service-catalog', 'list'] as const,
  list: (filters: ServiceCatalogListFilters) => ['service-catalog', 'list', filters] as const,
  /** Egy szolgáltatás TELJES részlete (service + plans[]+prices[]) — a háromszintű szerkesztő előtöltéséhez. */
  detail: (id: string) => ['service-catalog', 'detail', id] as const,
};
